import { PositionAbsolute, Text, TextInline } from '@trmediaab/zebra';
import { useRef } from 'react';
import { Tooltip } from 'react-tooltip';

let uniqueId = 0;
const getUniqueId = () => uniqueId++;
const useUniqueId = prefix => {
  const idRef = useRef(getUniqueId());
  return `${prefix}_${idRef.current}`;
};

const ShoeTooltip = ({ id, content }) =>
  content ? (
    <Tooltip id={id}>
      {content.map((line, index) => (
        <Text key={index} fontWeight="normal">
          {line}
        </Text>
      ))}
    </Tooltip>
  ) : null;

function Shoe(props) {
  const shod =
    (props.side === 'back' && props.data.back) ||
    (props.side === 'front' && props.data.front);
  const isChange =
    (props.side === 'back' && props.data.backChanged) ||
    (props.side === 'front' && props.data.frontChanged);

  return (
    <TextInline
      sx={{ position: 'relative' }}
      color={isChange ? '#EB123A' : 'black'}
      userSelect="none"
    >
      {shod ? (
        'C'
      ) : !shod ? (
        'Ȼ'
      ) : (
        <>
          C
          {!shod && (
            <PositionAbsolute
              top="-3px"
              left="1px"
              bottom="0"
              sx={{
                transform: 'scale(1.3)',
                fontWeight: props.variant !== 'plain' ? 'medium' : undefined,
              }}
            >
              /
            </PositionAbsolute>
          )}
        </>
      )}
    </TextInline>
  );
}

export function Shoes({ data, tooltipEnabled = false, ...textProps }) {
  const tooltipId = useUniqueId('tooltip-shoes');

  if (data.value == null && data.front == null && data.back == null) {
    return <Text {...textProps}>-</Text>;
  }

  const tooltipContent =
    data.value == null
      ? ['Skoinfo saknas.']
      : [
          data.isFirstTime ? 'För första gången.' : null,
          data.isChanged ? `Senast: ${data.previousValue}` : null,
        ].filter(Boolean);

  return (
    <Text
      {...(tooltipEnabled && { 'data-tooltip-id': tooltipId })}
      textDecoration={data.isChanged ? 'underline dotted #EB123A' : undefined}
      {...textProps}
    >
      <Shoe data={data} side="front" />
      <Shoe data={data} side="back" />
      {tooltipEnabled && tooltipContent.length > 0 && (
        <ShoeTooltip id={tooltipId} content={tooltipContent} />
      )}
    </Text>
  );
}
